import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#1A1716]" data-testid="admin-login-page">
      <div className="hidden lg:flex items-center justify-center relative grain bg-[#2F2A28]">
        <img src="/brand/helium-logo.svg" alt="Hélium Résidences" className="w-72 h-auto" data-testid="admin-login-logo" />
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="admin-login-form">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm" data-testid="admin-login-back-link"><ArrowLeft className="h-4 w-4" /> Retour au site</Link>
          <div>
            <p className="eyebrow">Espace administrateur</p>
            <h1 className="font-display text-4xl text-white mt-3">Connexion</h1>
          </div>
          <div className="space-y-2">
            <Label className="text-white/70">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white/5 border-white/15 text-white" data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label className="text-white/70">Mot de passe</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white/5 border-white/15 text-white" data-testid="admin-login-password" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full h-12 bg-[#C88A58] hover:bg-[#b57849] disabled:opacity-60 text-white rounded-full text-sm inline-flex items-center justify-center gap-2 transition-colors" data-testid="admin-login-submit">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
